import { Icon } from '@modulor/react';
import {
  ROOT,
  BONUSES,
  BONUS_HISTORY,
  RULES,
  BONUSES_COLLECTING_GAMES,
  BONUSES_WAGERING_GAMES,
  BONUSES_WAGERING_GAMES_SCCOM,
  SPECIAL_OFFERS,
  HALL_OF_FAME,
  SEARCH,
  PARAM_NAME,
  CATEGORY_DETAIL,
  TOURNAMENTS,
} from './routeTemplates';
import { ANALYTICS_SCREEN_AREA_DETAILS } from '../constants/analytics';
import { EVENT_ACTION } from './ga';
import { RECENT_GAMES_CATEGORY } from '../redux/constants/categories';

export const ROOT_NAV_ITEM = {
  IconComponent: () => <Icon name="home_outlined" />,
  translationKey: 'LOBBY',
  link: ROOT,
  eventAction: EVENT_ACTION.NAV_LOBBY,
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.MAIN_PAGE,
};
export const SEARCH_NAV_ITEM = {
  IconComponent: () => <Icon name="search" />,
  translationKey: 'SEARCH',
  link: SEARCH,
  eventAction: EVENT_ACTION.NAV_SEARCH,
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.SEARCH,
};
export const SPECIAL_OFFERS_NAV_ITEM = {
  IconComponent: () => <Icon name="hexagram_outlined" />,
  translationKey: 'SPECIAL_OFFERS',
  link: SPECIAL_OFFERS,
  eventAction: EVENT_ACTION.NAV_PROMO,
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.PROMO,
};
export const BONUSES_NAV_ITEM = {
  IconComponent: () => <Icon name="gift_outlined" />,
  translationKey: 'BONUSES',
  link: BONUSES,
  eventAction: EVENT_ACTION.NAV_BONUSES,
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.BONUS,
};
export const TOURNAMENT_NAV_ITEM = {
  IconComponent: () => <Icon name="cup_outlined" />,
  translationKey: 'Tournaments',
  link: TOURNAMENTS,
};
export const RULES_NAV_ITEM = {
  translationKey: 'RULES',
  link: RULES,
  eventAction: EVENT_ACTION.NAV_HOW_TO_PLAY,
  IconComponent: () => <Icon name="question_outlined" />,
  category_id: 'general',
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.HOW_TO_PLAY,
};
export const HALL_OF_FAME_NAV_ITEM = {
  translationKey: 'HALL_OF_FAME',
  link: HALL_OF_FAME,
  eventAction: EVENT_ACTION.NAV_HALL_OF_FAME,
  IconComponent: () => <Icon name="hall_of_fame_outlined" />,
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.HALL_OF_FAME,
};
export const BOUSES_COLLECTING_GAMES_NAV_ITEM = {
  IconComponent: () => <Icon name="cashback" />,
  translationKey: 'BONUSES_COLLECTING_GAMES',
  link: BONUSES_COLLECTING_GAMES,
  eventAction: EVENT_ACTION.NAV_COLLECTING_GAMES,
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.COLLECTING_GAMES,
};
export const BOUSES_WAGERING_GAMES_NAV_ITEM = {
  IconComponent: () => <Icon name="wager" />,
  translationKey: 'BONUSES_WAGERING_GAMES',
  link: BONUSES_WAGERING_GAMES,
  eventAction: EVENT_ACTION.NAV_WAGERING_GAMES,
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.WAGERING_GAMES,
};

export const BONUSES_WAGERING_GAMES_NAV_ITEM_SCCOM = {
  IconComponent: () => <Icon name="wager" />,
  translationKey: 'BONUSES_WAGERING_GAMES',
  link: BONUSES_WAGERING_GAMES_SCCOM,
  eventAction: EVENT_ACTION.NAV_WAGERING_GAMES,
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.WAGERING_GAMES,
};

export const RECENT_CATEGORY = {
  id: RECENT_GAMES_CATEGORY,
  translationKey: 'Recent',
};

export const RECENT_GAMES_SCCOM = {
  id: RECENT_GAMES_CATEGORY,
  IconComponent: () => <Icon name="gift_outlined" />,
  translationKey: 'Recent games',
  link: CATEGORY_DETAIL.replace(
    `:${PARAM_NAME.CATEGORY}`,
    RECENT_GAMES_CATEGORY
  ),
  eventAction: EVENT_ACTION.NAV_RECENT_GAMES,
};

export const MOBILE_ROUTES_WITH_BONUSES_HEADER = [BONUSES, BONUS_HISTORY];
export const MOBILE_ROUTES_WITHOUT_HEADER = [];
export const MOBILE_ROUTES_WITHOUT_HEADER_SCCOM = [SEARCH];
export const DESKTOP_ROUTES_WITHOUT_HEADER = [ROOT];
export const DESKTOP_ROUTES_WITHOUT_HEADER_SCCOM = [ROOT, SEARCH];

export const NAVIGATION_LINK_TYPES = {
  DEEPLINK: 'deeplink',
  INTERNAL: 'internal',
  SERVICE: 'service',
};
